// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"Header_logoContainer__DRgkx","logo":"Header_logo__2RA8C","header":"Header_header__3VW9R"};